import {Component} from '@angular/core';

@Component({
    selector: 'app-login-portal-info',
    templateUrl: './portal-info.component.html',
    styleUrls: ['./portal-info.component.scss'],
})
export class PortalInfoComponent {}
